import React, { useEffect} from "react";
import AOS from "aos";
import "aos/dist/aos.css";

import "../assets/css/about_style.css"; // Create this CSS file
import "../assets/css/Responsive/about_responsive.css";
import caliperImg from "../assets/images/about/caliper.webp";
import factoryImg from "../assets/images/about/factory.webp";
import brassImg from "../assets/images/about/brass_parts.webp";
// import { FaUsers, FaCogs } from "react-icons/fa";
import ourmission from "../assets/images/about/our-mission.webp";
import ourvalues from "../assets/images/about/our-values.webp";
import isoCertificate from "../assets/images/about/iso_certificate.webp";

export default function About() {
  document.title = "Milan Brass – About Us";
  useEffect(() => {
    AOS.init({
      duration: 1500, // default animation duration
      once: true, // animation runs only once
    });
    AOS.refresh();
  }, []);

  return (
    <div className="about-page">
      {/* Hero Section */}
      <section className="about-section-1">
        <div className="about-content-1">
          <div
            className="about-text-1"
            data-aos="fade-right"
            data-aos-duration="1500"
          >
            <h2>About Us</h2>
            <p>
              Crafting quality brass products with precision, <br />
              passion, and decades of trust.
            </p>
          </div>
          <div
            className="about-image"
            data-aos="fade-left"
            data-aos-duration="1500"
          >
            <img src={caliperImg} alt="Measuring brass product" />
          </div>
        </div>
      </section>

      {/* About Milan Brass */}
      <section className="about-section">
        <h2 data-aos="fade-up" data-aos-duration="1200">
          About Milan Brass
        </h2>
        <hr data-aos="fade-up" data-aos-duration="1200" data-aos-delay="100" />

        <div className="about-content">
          <div
            className="about-text"
            data-aos="fade-right"
            data-aos-duration="1500"
          >
            <p>
              Established in this industry in the year 2018, "Milan Brass" is
              one of a well reputable firm in this product sector. We are
              engaged as a Manufacturer and Trading of Brass Nut, Brass Insert,
              Etc.
            </p>
            <p>
              Milan Brass Industry is a trusted name in the manufacturing of
              high-quality brass components, known for precision engineering,
              durability, and innovation. With years of expertise and a
              commitment to excellence, we serve diverse industries including
              electrical, plumbing, automotive, and hardware.
            </p>
          </div>

          <div
            className="about-img"
            data-aos="fade-left"
            data-aos-duration="1500"
          >
            <img src={factoryImg} alt="Factory" />
          </div>
        </div>

        <div className="about-content reverse">
          <div
            className="about-img"
            data-aos="fade-right"
            data-aos-duration="1500"
          >
            <img src={brassImg} alt="Brass Products" />
          </div>

          <div
            className="about-text"
            data-aos="fade-left"
            data-aos-duration="1500"
          >
            <p>
              Our state-of-the-art infrastructure, skilled workforce, and strict
              quality control standards ensure that every product meets global
              benchmarks. At Milan Brass, we believe in building long-term
              partnerships by delivering reliability, consistency, and value.
            </p>
            <p>
              Driven by a vision to lead in brass manufacturing, Milan Brass
              Industry constantly embraces new technologies and sustainable
              practices. Our customer-centric approach, timely delivery, and
              ability to customize solutions have earned us a loyal client base
              both in India and overseas. As we grow, we continue to uphold the
              values of integrity, craftsmanship, and continuous improvement in
              everything we do.
            </p>
          </div>
        </div>
      </section>
      {/* <div className="about-container">
        <section className="core-values-mission">
          <div className="core-values">
            <h2>Our Core Values</h2>
            <p>
              Ethical Practice, Customer Focus, Commitment and Transparent
              Management. Emphasis on Human Resources Development, Cost
              Reduction, Productivity Enhancement, and Resource Conservation,
              Empowerment and Accountability.
            </p>
          </div>
          <div className="mission">
            <h2>Our Mission</h2>
            <p>
              Our Mission is to Manufacture Quality Products at Competitive Cost
              through Technology & Teamwork and build Strong Relationships with
              Suppliers and Customers.
            </p>
          </div>
        </section>

        <section className="founder-message">
          <h2>Message from the Founder</h2>
          <blockquote>
            We want to be the world leader in manufacturing precision customized
            brass components for the brass industries and to excel as a trusted,
            socially responsible, and customer-driven organization providing
            maximum value to all stakeholders.
          </blockquote>
          <p className="founder-name">Milan Sudani</p>
        </section>
      </div> */}
      {/* Core Values & Mission */}
      <div className="core-mission-section">
        <div
          className="core-values"
          data-aos="fade-up"
          data-aos-duration="1500"
        >
          {/* <FaUsers size={40} /> */}
          <img src={ourvalues} alt="ourvalues-icon" />
          <h3>Our Core Values</h3>
          <p>
            Ethical Practice, Customer Focus, Commitment and Transparent
            Management. Emphasis on Human Resources Development, Cost Reduction,
            Productivity Enhancement, and Resource Conservation, Empowerment and
            Accountability.
          </p>
        </div>
        <div className="vertical-divider" />
        <div
          className="mission"
          data-aos="fade-up"
          data-aos-duration="1500"
          data-aos-delay="200"
        >
          {/* <FaCogs size={40} /> */}
          <img src={ourmission} alt="our-mission-icon" />
          <h3>Our Mission</h3>
          <p>
            Our Mission is to Manufacture Quality Products at Competitive Cost
            through Technology & Teamwork and build Strong Relationships with
            Suppliers and Customers.
          </p>
        </div>
      </div>

      {/* Founder Message */}
      <div
        className="founder-message"
        data-aos="fade-up"
        data-aos-duration="1500"
      >
        <h2>Message from the Founder</h2>
        <blockquote>
          <p>
            We want to be the world leader in manufacturing precision customized
            brass components for the brass industries and to excel as a trusted,
            socially responsible, and customer-driven organization providing
            maximum value to all stakeholders.
          </p>
        </blockquote>
        <hr />
        <p className="founder-name">Milan Sudani</p>
      </div>

      {/* Certification Section */}
      <div
        className="certification-section"
        data-aos="fade-up"
        data-aos-duration="1500"
      >
        <h2>Our Certification</h2>
        <p>
          We are proud to be ISO certified, ensuring the highest quality
          standards in our manufacturing process.
        </p>
        <div className="certificate-image">
          <img src={isoCertificate} alt="ISO Certification" />
        </div>
        <div className="certificate-details">
          <h3>
            GSTIN : <span>24CCSPS4509L1ZY</span>{" "}
          </h3>
        </div>
      </div>
      {/* Certification Section */}
      {/* <div
        className="certification-section card-layout"
        data-aos="fade-up"
        data-aos-duration="1500"
      >
        <h2>Our Certification</h2>
        <div className="certificate-card">
         
          <div className="certificate-img-wrapper">
            <img src={isoCertificate} alt="ISO Certification" />
          </div>

         
          <div className="certificate-details">
            <h3>ISO Certification</h3>
            <p>
              We are proud to be ISO certified, which ensures the highest
              quality standards in our manufacturing process. This certification
              reflects our commitment to excellence, reliability, and customer
              satisfaction.
            </p>
            <p className="certificate-date">Issued: 2023</p>
            <h3>GSTIN :</h3>
            <p className="gst-no">
              {" "}
              <i>GST NO: </i> 24CCSPS4509L1ZY
            </p>
          </div>
        </div>
      </div> */}
    </div>
  );
}
